import { watch } from 'vue';

import { Capacitor } from '@capacitor/core';
import { useDeviceStore } from '/src/store/stores/useDeviceStore.js';
import { useNfcStore } from '/src/store/stores/useNfcStore.js';
import { useNativeNfc } from '/src/native/useNativeNfc.js';

// device store
const { configurations } = useDeviceStore();

// nfc store
const {
	setSupported,
	setEnabled,
} = useNfcStore();

// nfc
const {
	isSupported,
	isEnabled,
} = useNativeNfc();

// platform
const isNativePlatform = Capacitor.isNativePlatform();

export function useNfcService () {
	let interval, removeWatcher;

	async function checkNfcStatus () {
		try {
			const { isSupported: supported } = await isSupported();
			setSupported(supported && isNativePlatform);

			const { isEnabled: enabled } = await isEnabled();
			setEnabled(enabled && isNativePlatform);
		} catch (error) {
			console.warn('[NFC] checkNfcStatus failed:', error);
		}
	}

	async function start () {
		stop();

		if (!isNativePlatform) {
			setSupported(false);
			setEnabled(false);
			return;
		}

		checkNfcStatus();

		interval = setInterval(() => {
			checkNfcStatus();
		}, 30000);

		removeWatcher = watch(() => configurations.value, (config) => {
			if (!config?.NfcConfiguration || config.NfcConfiguration.enabled) {
				return;
			}

			stop();
		}, { deep: true });
	}

	function stopPolling () {
		if (interval) {
			clearInterval(interval);
			interval = null;
		}
	}

	function stop () {
		stopPolling();
		if (removeWatcher) {
			removeWatcher();
			removeWatcher = null;
		}
	}

	return {
		start,
		stop,
	};
}
